import * as _m0 from "protobufjs/minimal";
import { GetCasesRequest, GetCasesResponse } from "../getcases";
import { withAuthRetry } from '../utils/authRetry';

export async function getCases(request: GetCasesRequest, accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<GetCasesResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv') === 'true';

        let url = `https://rnmjoi8ycf.execute-api.us-west-2.amazonaws.com/adminservice/getcases?offset=${request.offset}&page_size=${request.pageSize}`;
        if (staging) {
            const urlParts = url.split('?');
            url = `${urlParts[0]}-staging?${urlParts[1]}`;
        }

        const response = await fetch(
            url, {
            method: 'GET',
            headers,
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): GetCasesResponse => {
        return GetCasesResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
